var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-container",class:{ animate: _vm.animated },on:{"flash-points":_vm.animate,"animationend":function($event){return _vm.nextAnimation()}}},[_vm._v(" "+_vm._s(_vm.animationValue)+" points ")])}
var staticRenderFns = []

export { render, staticRenderFns }